[
  {
    "identifier": "match_donor_code",
    "header": "Donor",
    "field": "donor.code",
    "editable": false,
    "statusIcon": true,
    "isVisible": true,
    "isSortable": false
  },
  {
    "identifier": "match_organ",
    "header": "Organ",
    "field": "organ.organ_group.name",
    "editable": false,
    "isVisible": true,
    "isSortable": false
  },
  {
    "identifier": "match_code",
    "header": "Match",
    "field": "code",
    "editable": false,
    "isVisible": true,
    "isSortable": false
  },
  {
    "identifier": "match_transplant_center",
    "header": "TC",
    "field": "transplantCenter.code",
    "editable": false,
    "isVisible": true,
    "isSortable": false
  },
  {
    "identifier": "match_opo",
    "header": "OPO",
    "field": "donor.opo.code",
    "editable": false,
    "isVisible": true,
    "isSortable": false
  },
  {
    "identifier": "donor_age",
    "header": "Donor Age",
    "field": "donor.age",
    "editable": false,
    "isVisible": true,
    "isSortable": false
  },
  {
    "identifier": "donor_dcd",
    "header": "BD/DCD",
    "field": "donor.dcd_criteria_meets.display",
    "editable": false,
    "isVisible": true,
    "isSortable": false
  },
  {
    "identifier": "or_datetime",
    "header": "OR Time",
    "field": "donor.or_datetime.display",
    "editable": false,
    "isVisible": true,
    "isSortable": true,
    "sortField": "or_datetime"
  },
  {
    "identifier": "donor_crossclamp_date",
    "header": "Cross clamp date",
    "field": "donor.cross_clamp_datetime.display",
    "editable": false,
    "isVisible": true,
    "isSortable": true,
    "sortField": "cross_clamp_datetime"
  },
  {
    "identifier": "donor_elapsed_time",
    "header": "Elapsed Time",
    "field": "elapsed_time.display",
    "editable": false,
    "isVisible": true,
    "isSortable": true,
    "sortField": "elapsed_time"
  },
  {
    "identifier": "last_update",
    "header": "Last Update",
    "field": "last_update.display",
    "editable": false,
    "isVisible": true,
    "isSortable": true,
    "sortField": "offer_date"
  },
  {
    "identifier": "seq",
    "header": "Seq.",
    "field": "match_effective_value.effective_seq",
    "editable": false,
    "isVisible": true,
    "isSortable": true,
    "sortField": "seq"
  },
  {
    "identifier": "rank",
    "header": "Rank",
    "field": "match_effective_value.effective_rank",
    "editable": false,
    "isVisible": true,
    "isSortable": true,
    "sortField": "rank"
  },
  {
    "identifier": "status",
    "header": "Status",
    "field": "status.name",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "next_step",
    "header": "Next Step",
    "field": "next_step",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "match_coordinator_note",
    "header": "Most Recent Coordinator Note",
    "field": "coordinator_note.note",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "assigned_to_full_name",
    "header": "Assigned To",
    "field": "assignment.assigned_to.full_name",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "checklist_status",
    "header": "Checklist status",
    "field": "checklist.status",
    "editable": false,
    "isVisible": false,
    "permission": "internal_match_checklists"
  },
  {
    "identifier": "checklist_checklist_started_at",
    "header": "Checklist started at",
    "field": "checklist.checklist_started_at.display",
    "sortField": "checklist_started_at",
    "editable": false,
    "isVisible": false,
    "permission": "internal_match_checklists"
  },
  {
    "identifier": "checklist_verified_at",
    "header": "Checklist verified at",
    "field": "checklist.verified_at.display",
    "editable": false,
    "isVisible": false,
    "permission": "internal_match_checklists"
  },
  {
    "identifier": "checklist_verified_by_full_name",
    "header": "Checklist verified by",
    "field": "checklist.verified_by.full_name",
    "editable": false,
    "isVisible": false,
    "permission": "internal_match_checklists"
  }
]